import Button from "@components/Button"
import Layout from "@components/Layout"
import { useTranslation } from "react-i18next"
import { Form, useSubmit } from "react-router-dom"

export default function SocialProof() {
  const { t } = useTranslation()
  const submit = useSubmit()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    submit(event.currentTarget)
  }

  return (
    <Layout>
      <div className="flex grow flex-col items-center justify-center px-4">
        <p className="mb-6 text-lg font-semibold text-gray-500">
          {t("pages.onboarding.socialProof.trustedBy")}
        </p>

        <div className="mb-8 flex flex-col items-center">
          <div className="mb-4 flex items-center gap-1">
            {Array.from({ length: 5 }).map((_, i) => (
              <svg
                key={i}
                className="text-custom-teal h-7 w-7"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
              </svg>
            ))}
          </div>

          <p className="text-custom-charcoal text-5xl font-bold">4.7</p>
          <p className="mt-1 text-sm text-gray-400">
            {t("pages.onboarding.socialProof.topRated")}
          </p>
        </div>

        <h1 className="custom-heading mb-2">
          {t("pages.onboarding.socialProof.heading")}
        </h1>
        <p className="text-center text-sm text-gray-400">
          {t("pages.onboarding.socialProof.basedOn")}
        </p>
      </div>

      <div className="sticky bottom-0 -mx-5 bg-gradient-to-t from-white from-70% to-transparent px-5 pt-8 pb-4">
        <Form method="post" onSubmit={handleSubmit}>
          <input name="socialProof" type="hidden" value="continue" />
          <Button title={t("shared.continue")} type="submit" />
        </Form>
      </div>
    </Layout>
  )
}
